import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Route, Routes, useNavigate } from 'react-router-dom';


import toast from 'react-hot-toast';
import { DatePicker, Space } from 'antd';
import moment from 'moment';
import { DataContext } from '../../../init/getData';

import Chart from "react-apexcharts";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';


const MonthlySales = (props) => {

  const { userData, settingData, devData, api, companyId, yearId, selectedYear, contentLanguages } = useContext(DataContext);


  const [loadingCounter, setLoadingCounter] = useState(0);
  const [monthlySales, setMonthlySales] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState({ value: 'January', label: 'January' });


  useEffect(() => {
    getData();
  }, [selectedMonth]);


  const getData = async () => {

    let data = {
      selectedYear,
      selectedMonth,
      companyId,
      yearId,
      settingData,
      branchId: null,
    };

    await api.get(`/dashBoard/getSalesMonthly`, { params: data }).then(response => {
      if (!response.data.status) {
        toast.error('Failed to get Data')
      } else {
        setMonthlySales(response.data?.monthlySales)
      }
    }
    )

  }

  const monthOptions = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const [chartOptions, setChartOptions] = useState({
    chart: {
      id: "basic-line-chart",
    },
    xaxis: {
      categories: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    },
  });

  // Chart data
  const chartSeries = [
    {
      name: "Sales",
      data: [
        monthlySales?.January?.secondarySalesRevenue,
        monthlySales?.February?.secondarySalesRevenue,
        monthlySales?.March?.secondarySalesRevenue,
        monthlySales?.April?.secondarySalesRevenue,
        monthlySales?.May?.secondarySalesRevenue,
        monthlySales?.June?.secondarySalesRevenue,
        monthlySales?.July?.secondarySalesRevenue,
        monthlySales?.August?.secondarySalesRevenue,
        monthlySales?.September?.secondarySalesRevenue,
        monthlySales?.October?.secondarySalesRevenue,
        monthlySales?.November?.secondarySalesRevenue,
        monthlySales?.December?.secondarySalesRevenue,
      ]
    },
  ]


  return (

    <div>
      {monthlySales &&
        <div>
          <Select
            styles={selectStyles}
            options={monthOptions}
            isSearchable={true}
            placeholder="Select Month..."
            onChange={setSelectedMonth}
            value={selectedMonth}
            required
          />
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="line" // Chart type: 'line', 'bar', 'pie', etc.
            height="350"
          />
        </div>
      }
    </div>

  );
}


export default MonthlySales;